import { CertificateRequestStatus } from "@tfg/db/browser"
import { Select } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { removeUndefined } from "@tfg/types/schemas/utils"

import { FindCertificateRequestsForSupplierQueryParams } from "~/gen/api/types/FindCertificateRequestsForSupplier"

type Props = {
  params: FindCertificateRequestsForSupplierQueryParams
  setParams: Dispatch<
    SetStateAction<FindCertificateRequestsForSupplierQueryParams>
  >
}

export const CertificateRequestStatusFilter = ({
  params,
  setParams,
}: Props) => {
  const { t } = useTranslation(["traceability"])

  const STATUS_OPTIONS = [
    {
      label: t("certificateRequestStatus.OPENED"),
      value: CertificateRequestStatus.OPENED,
    },
    {
      label: t("certificateRequestStatus.SUBMITTED"),
      value: CertificateRequestStatus.SUBMITTED,
    },
    {
      label: t("certificateRequestStatus.REJECTED"),
      value: CertificateRequestStatus.REJECTED,
    },
    {
      label: t("certificateRequestStatus.ACCEPTED"),
      value: CertificateRequestStatus.ACCEPTED,
    },
  ]
  return (
    <Select
      placeholder={t("filters.status.placeholder")}
      value={params.status ?? null}
      onChange={(val) => {
        if (val && isCertificateRequestStatus(val)) {
          setParams((prev) => ({ ...prev, status: val }))
        } else {
          setParams((prev) => removeUndefined({ ...prev, status: undefined }))
        }
      }}
      data={STATUS_OPTIONS}
      w={180}
      clearable
    />
  )
}

const isCertificateRequestStatus = (
  val: string
): val is CertificateRequestStatus => {
  return Object.keys(CertificateRequestStatus).includes(val)
}
